import React from 'react';

const Value = ({value}) => (
    <>
        <span className="value">{value}</span>
    </>
);

export default Value;
